import { Spinner } from "@/components/Spinner";

export const Loading = () => (
  <div className="flex flex-col h-dvh w-dvw overflow-hidden bg-muted">
    {/* Top bar */}
    <div className="w-full bg-background shadow-sm px-6 py-4">
      <h2 className="text-xl font-semibold">17reviews</h2>
    </div>

    {/* Main content area with centered spinner */}
    <div className="flex flex-col items-center justify-center flex-1">
      <div className="relative">
        {/* Spinner container */}
        <div className="p-8 flex flex-col items-center">
          <Spinner />
        </div>

        {/* Adding the stacked card effect similar to the SignIn component */}
        <div className="absolute bg-background rounded-lg shadow-md w-[98%] h-[98%] bottom-[-4px] left-[1%] -z-10"></div>
        <div className="absolute bg-background rounded-lg shadow-sm w-[96%] h-[96%] bottom-[-8px] left-[2%] -z-20"></div>
      </div>
    </div>
  </div>
);
